// item.ts
import { Component, input, output } from '@angular/core';
import { Badge } from '../badge/badge';

@Component({
  selector: 'app-item',
  imports: [Badge],
  templateUrl: './item.html',
})
export class Item {
  id = input<string>();
  name = input<string>();
  selector = input<'checkbox' | 'radio' | undefined>();
  difficulty = input<string>();
  title = input<string>();
  description = input<string>();
  duration = input<number>();
  selectedValue = input<string>(); // Add this to track selected value
  selectItem = output<string>();

  // Helper method to check if this item is selected
  isSelected(): boolean {
    return this.selectedValue() === this.id();
  }
  stripHtmlTags(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  }
}
